export const useOS = (): OsCheck | null => {
	if (!navigator || !navigator?.userAgent) {
		return null;
	}

	const userAgent = navigator.userAgent.toLowerCase();

	// iOS (includes iPadOS 13+ which masquerades as Mac)
	const isIOS =
		/iphone|ipod|ipad/.test(userAgent) ||
		(userAgent.includes('macintosh') && 'ontouchend' in window);

	if (isIOS) {
		return {
			os: 'ios',
			type: 'mobile',
		};
	}

	if (/android/.test(userAgent)) {
		return {
			os: 'android',
			type: 'mobile',
		};
	}

	if (userAgent.includes('macintosh') || userAgent.includes('mac os')) {
		return {
			os: 'mac',
			type: 'desktop',
		};
	}

	if (userAgent.includes('windows')) {
		return {
			os: 'windows',
			type: 'desktop',
		};
	}

	if (userAgent.includes('linux')) {
		return {
			os: 'linux',
			type: 'desktop',
		};
	}

	return null;
};

type OperatingSystemType = 'ios' | 'android' | 'mac' | 'windows' | 'linux';

export interface OsCheck {
	os: OperatingSystemType;
	type: 'mobile' | 'desktop';
}
